import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {autobind} from 'core-decorators';
import {graphql, withApollo} from 'react-apollo';
import {reverse} from 'core/urls';
import {
    isSessionSupervisor,
    parseQueryString,
    addQueryParams,
    removeEmptyValues,
    getCurrentPage,
    getPageFromQS,
    getMaxPage,
} from 'core/utils';
import userQuery from 'graphql/queries/user.gql';
import ordersQuery from 'graphql/queries/orders.gql';
import Spinner from 'components/spinner';
import SectionBanner from 'components/section-banner';
import Filters from 'components/filters';
import OrderGrid from 'components/order-grid';
import OrderTable from 'components/order-table';
import FilteredElementsCount from 'components/filtered-elements-count';
import Pagination from 'components/pagination';
import styles from './styles.css';
import OrdersExportData from './order-list-export';

@graphql(userQuery, {name: 'userData'})
@withApollo
@autobind
export default class OrderList extends Component {
    static contextTypes = {
        router: PropTypes.object,
    };

    state = {
        orders: {},
        loading: true,
    };

    componentDidMount() {
        this.load(this.props.location.search);
    }

    componentWillReceiveProps(nextProps) {
        this.load(nextProps.location.search);
    }

    pageSize = 13;

    async load(locationProps) {
        const params = parseQueryString(locationProps) || {};
        const page = !!params.page ? params.page : 0;
        this.setState({loading: true});
        const response = await this.makeRequest({...params, page, pageSize:this.pageSize});
        this.setState({orders: response.data.orders, loading: false});
    }

    async makeRequest(params) {
        const options = removeEmptyValues(params);
        const response = await this.props.client.query({
            fetchPolicy: 'network-only',
            query: ordersQuery,
            variables: {
                options: {...options}
            },
        });
        return response;
    }



    getTitle() {
        return isSessionSupervisor(this.props.userData.user) ? 'Pedidos' : 'Historial de pedidos';
    }

    getFilters() {
        const filters = ['id', 'orderCategory', 'orderStatus', 'shipmentStatus'];
        if (isSessionSupervisor(this.props.userData.user)) {
            filters.push(
                'organizationCategory',
                'organization',
                'season',
                'region',
                'salesUser',
            );
        }
        return filters;
    }

    async handleExportOrders() {
        const params = parseQueryString(this.props.location.search) || {};
        const page = 0;
        const response = await this.makeRequest({...params, page, pageSize:this.state.orders.count});
        return response.data;
    }

    handleFilterChange(params, resetPage = false) {
        const {history} = this.context.router;
        const oldParams = parseQueryString(this.props.location.search) || {};
        const page = resetPage ? 0 : getPageFromQS(oldParams, params);
        addQueryParams({...params, page}, history, this.props.location);
    }

    handleOrderClick(id) {
        window.open(reverse('orderDetail', {id}), '_blank');
    }

    handlePreviousPage(page) {
        return () => {
            if (page >= 0) this.handleFilterChange({page: page-1});
        };
    }

    handleNextPage(page, maxPage) {
        return () => {
            if (page <= maxPage) this.handleFilterChange({page: page+1});
        };
    }

    handlePageClick(number) {
        this.handleFilterChange({page: number});
    }

    renderOrders(orders) {
        if (isSessionSupervisor(this.props.userData.user)) {
            return <OrderTable orders={orders} onOrderclick={this.handleOrderClick} totalOrders={this.state.orders.count}/>;
        }
        return <OrderGrid orders={orders} columns={2} />;
    }

    render() {
        if (this.props.userData.loading) return <Spinner />;
        const page = getCurrentPage(this.props.location);
        const maxPage = getMaxPage(this.state.orders.count, this.pageSize);

        return (
            <div className={styles.root}>
                <div className={styles.background} />
                <SectionBanner />
                <Filters filters={this.getFilters()} onChange={(params) => this.handleFilterChange(params, true)} />
                <div className={styles.tableDiv}>
                    {this.state.loading ? <Spinner /> : (
                        <div container className={styles.content}>
                            {this.state.orders.count > 0 && <OrdersExportData handleClick={this.handleExportOrders} />}
                            <div className={styles.orders}>
                                {
                                    this.state.orders.count > 0 ?
                                    this.renderOrders(this.state.orders.items) :
                                    <FilteredElementsCount count={this.state.orders.count} elementName='pedido' />
                                }
                            </div>
                        </div>
                    )}
                    {maxPage > 0 && (
                        <Pagination
                            maxPage={maxPage}
                            active={page}
                            handlePreviousPage={this.handlePreviousPage(page)}
                            handleNextPage={this.handleNextPage(page, maxPage)}
                            handlePageClick={this.handlePageClick}
                        />
                    )}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./views/order-list/index.js